import "../css/reset.css";
import EditStudyForm from "../components/EditStudyComponents/EditStudyForm.js";
function EditStudyPage() {
  return (
    <>
      <EditStudyForm />
    </>
  );
}

export default EditStudyPage;
